module.exports = __webpack_public_path__ + "assets/images/cosmote_6.13253510ab8f6194b91f6571a3d542f0.png";